import React from 'react'

const LoanListPage = React.lazy(() => import('../components/LoanListPage'))

export { LoanListPage }
